export const CHAT_ONBOARDING_STEPS = [
  {
    id: 'welcome',
    target: null,
    title: 'Welcome to PickStar AI Chat',
    content: 'Your intelligent sports betting assistant is ready to help. Let me show you how to make the most of our AI-powered chat experience.',
    position: 'center',
    action: null,
  },
  {
    id: 'message-input',
    target: '[data-chat-message-input]',
    title: 'Ask Anything About Sports',
    content: 'Type your questions here. Ask about game predictions, player stats, betting strategies, or any sports-related analysis.',
    position: 'top',
    mobilePosition: 'top',
    action: null,
  },
  {
    id: 'top-banner-tools',
    target: '[data-top-banner]',
    title: 'Powerful Tools & Features',
    content: 'Access key tools: Buy Star Coins for premium features, run Spin the Wheel for detailed game analysis, automate custom prompts with Kits, and browse your full Chat History.',
    position: 'bottom',
    mobilePosition: 'bottom',
    action: null,
  },
  {
    id: 'complete',
    target: null,
    title: 'Ready to Chat',
    content: 'You are all set! Start asking PickStar AI about sports, betting strategies, or game predictions to get expert insights.',
    position: 'center',
    action: null,
  }
];

// Mobile-specific step configuration overrides
export const MOBILE_CHAT_STEPS_CONFIG = {
  'message-area': {
    scrollBehavior: 'smooth',
    scrollOffset: -100,
  },
  'message-input': {
    scrollBehavior: 'smooth',
    scrollOffset: -50,
  },
  'chat-history': {
    scrollBehavior: 'instant',
    scrollOffset: 0,
  }
};